import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HospitalComponent } from './manage/hospital.component';
import { AuthGuard } from '@shared/auth/auth-guard';
import { HospitalClaimsComponent } from './hospital-claims/hospital-claims.component';
import { HospitalAssignedComponent } from './hospital-assigned/hospital-assigned.component';
import { HospitalManagementComponent } from './hospital-management/hospital-management.component';

const routes: Routes = [
  { path: 'manage', component: HospitalComponent, canActivate: [ AuthGuard ] },
  { path: 'renewal', component: HospitalComponent, canActivate: [ AuthGuard ] },
  { path: 'assigned', component: HospitalAssignedComponent, canActivate: [ AuthGuard ] },
  { path: 'manage/:id', component: HospitalComponent, canActivate: [ AuthGuard ] },
  { path: 'ownerClaims', component: HospitalClaimsComponent, canActivate: [ AuthGuard ]},
  { path: 'claims', component: HospitalClaimsComponent, canActivate: [ AuthGuard ]},
  { path: 'admin', component: HospitalManagementComponent, canActivate: [ AuthGuard ]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HospitalRoutingModule { }
